const Globals = {
  API: process.env.REACT_APP_API_URL || "https://api.aviatortravel.tn",
  
  // Hotel API Provider Credentials
  hotelProvider: {
    login: "XMLAVIA",
    password: "$CZhuPF2SaSW3HXeX4Uw",
    baseUrl: "https://admin.mygo.co/api/hotel/"
  },

  // API Endpoints
  endpoints: {
    listCity: "ListCity",
    listBoarding: "ListBoarding",
    listTag: "ListTag",
    listCurrency: "ListCurrency",
    listHotel: "ListHotel",
    hotelDetail: "HotelDetail",
    hotelSearch: "HotelSearch",
    bookingCreation: "BookingCreation",
    bookingCancellation: "BookingCancellation",
    bookingList: "BookingList"
  }
};

export default Globals;
